import { Stack, Typography } from "@mui/material";

import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import RemoveIcon from "@mui/icons-material/Remove";

function Comment({ title }) {
  return (
    <div className="bg-white">
      <Stack
        direction="row"
        gap={1}
        width={{ sm: 600, lg: 750 }}
        px={{ xs: 5, sm: 0 }}
        py={10}
        mx="auto"
      >
        <FormatQuoteIcon sx={{ color: "primary.dark", fontSize: 30 }} />
        <Stack gap={2}>
          <Typography
            color="primary.dark"
            fontSize={23}
            fontStyle={"italic"}
            fontWeight={300}
          >
            {title}
          </Typography>
          <Stack direction="row" gap={1}>
            <RemoveIcon />
            <Typography fontWeight={300}>MEETFUTUR Homeowners</Typography>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
}

export default Comment;
